import {
  VERTICAL_POSITIONS, HORIZONTAL_POSITIONS
} from 'shared/UI/InlineDialog'
import { I18n, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS } from 'shared/services/I18n'

const TRANSLATION_KEY = TRANSLATION_KEYS.validationErrors
const i18n = I18n(FollozeState.initialState.locale)

export const CTA_FORM_NAMES = {
  sendMessage: 'sendMessage',
  getVisitorEmail: 'getVisitorEmail',
  customForm: 'customForm',
  customFormOnBoard: 'customFormOnBoard',
  gating: 'gating',
  share: 'share'
}

export const CUSTOM_FORM_FIELD_STATES = {
  optional: 'optional',
  invisible: 'invisible',
  required: 'required'
}

export const VALIDATION_ERRORS = {
  required: `* ${i18n.translate(TRANSLATION_KEY, TRANSLATION_VALUE_KEYS.requiredField)}`,
  email: `* ${i18n.translate(TRANSLATION_KEY, TRANSLATION_VALUE_KEYS.emailField)}`,
  accepted: `* ${i18n.translate(TRANSLATION_KEY, TRANSLATION_VALUE_KEYS.approvedField)}`
}

export const FORM_CTA_TYPES = {
  form: 'form',
  registration: 'registration'
}

export const CTA_FORM_VERTICAL_POSITIONS = VERTICAL_POSITIONS
export const CTA_FORM_HORIZONTAL_POSITIONS = HORIZONTAL_POSITIONS
